var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var HotTicketsFilters = function () {
            function HotTicketsFilters() {
                _classCallCheck(this, HotTicketsFilters);

                this.init();

                this.handlers();

                this.params = {
                    departure: null,
                    destination: null,
                    availability: null
                };

                this.isFirst = true;
            }

            _createClass(HotTicketsFilters, [{
                key: "init",
                value: function init() {}
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    document.addEventListener('DOMContentLoaded', function () {
                        window.mSelectSliders = { hotTicketsFilters: new MSelectSlider({ id: "hotTicketsFilters" }) };
                        _this.showHotTicketsResult();
                    });

                    eventDispatcher.addEventListener('_m-select-change-value', function (params) {
                        if (params.type === 'destinations') {
                            _this.params.destination = params.value;
                        }

                        if (params.type === 'departures') {
                            _this.params.departure = params.value;

                            var destinations = QS('#hot-tickets-destination-select .m-select-item-value');
                            var directions = window.aviaForm.directions;

                            var allowedTo = directions.filter(function (dir) {
                                return dir.from === params.value;
                            }).map(function (dir) {
                                return dir.to;
                            });

                            destinations.forEach(function (element) {
                                var opt = element.closest('.m-select__option');

                                if (params.value === '' && allowedTo.length === 0) {
                                    opt.classList.remove('hidden');
                                } else {
                                    if (!allowedTo.includes(element.value)) {
                                        if (!element.classList.contains('default')) {
                                            opt.classList.add('hidden');
                                        }
                                    } else {
                                        opt.classList.remove('hidden');
                                    }
                                }
                            });
                        }

                        if (params.type === 'availability') {
                            _this.params.availability = params.value;
                        }

                        _this.params.offset = 0;

                        var eventProperties = {};
                        eventProperties['Type'] = params.type;
                        window.brxTracking.sendAnalyticsEvent('apply_avia_widget_filter', eventProperties);

                        _this.showHotTicketsResult();
                    });

                    eventDispatcher.on('click', '.hot-tickets .m-select', function (event, element) {
                        var eventProperties = {};
                        eventProperties['Type'] = element.dataset.type;
                        window.brxTracking.sendAnalyticsEvent('open_avia_widget_filter', eventProperties);
                    });

                    document.body.addEventListener('_change-avia-departure', function (event) {
                        if (_this.isFirst) {
                            _this.isFirst = false;
                            return;
                        }
                        var value = event.detail.value;

                        var targetElement = QS('.m-select__input[name="hot-tickets-departure-select"]');
                        var option = QS("#hot-tickets-departure-select-" + value + "-radio");
                        var mSelectElement = targetElement ? targetElement.closest('.m-select') : null;
                        var optionWrapper = option ? option.closest('.m-select__option') : null;
                        var optionLabel = optionWrapper ? optionWrapper.querySelector('.m-select__option-label') : null;

                        if (!targetElement || !mSelectElement || !optionWrapper || !optionLabel) {
                            return;
                        }

                        eventDispatcher.dispatchEvent('_m-select-change-value', {
                            value: value,
                            name: optionLabel.textContent,
                            mSelectElement: mSelectElement,
                            type: mSelectElement.dataset.type
                        });
                    });

                    eventDispatcher.on('click', '.hot-tickets .m-select', function (event, element) {
                        var eventProperties = {};
                        eventProperties['Type'] = element.dataset.type;
                        window.brxTracking.sendAnalyticsEvent('open_avia_widget_filter', eventProperties);
                    });
                }
            }, {
                key: "showHotTicketsResult",
                value: function showHotTicketsResult() {
                    window.HotTickets.params = this.params;
                    window.HotTickets.offset = 0;
                    window.HotTickets.isAllowRequest = true;
                    window.HotTickets.isNeedScroll = true;
                    window.HotTickets.show(this.params);
                }
            }]);

            return HotTicketsFilters;
        }();

        window.HotTicketsFilters = HotTicketsFilters;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var _window = window,
            HotTicketsFilters = _window.HotTicketsFilters;

        var HotTickets = function () {
            function HotTickets() {
                _classCallCheck(this, HotTickets);

                this.elements = {
                    container: document.querySelector('#hot-tickets'),
                    list: document.querySelector('#hot-tickets-list'),
                    from: document.querySelector('#aviaHiddenDepart')
                };

                this.components = {
                    filter: new HotTicketsFilters()
                };

                this.items = null;

                this.params = {
                    departure: null,
                    destination: null,
                    availability: null,
                    offset: 0
                };

                this.offset = 0;
                this.isAllowRequest = true;
                this.isShowLoading = true;
                this.isNeedScroll = false;

                this.init();
            }

            _createClass(HotTickets, [{
                key: "init",
                value: function init() {
                    var _this2 = this;

                    var observer = new IntersectionObserver(function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting && _this2.isAllowRequest && !_this2.isShowLoading) {
                                _this2.show(_this2.params);
                            }
                        });
                    }, {
                        root: null,
                        threshold: 0
                    });

                    observer.observe(QS('.hot-tickets-bottom-sentinel'));
                }
            }, {
                key: "show",
                value: function show() {
                    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    if (params.departure !== this.params.departure || params.destination !== this.params.destination || params.availability !== this.params.availability) {
                        this.offset = 0;
                        this.isAllowRequest = true;
                    }

                    if (this.isNeedScroll) {
                        this.scroll();
                        this.isNeedScroll = false;
                    }

                    if (this.isAllowRequest) {
                        this.elements.container.classList.remove('hidden');

                        this.toggleLoading(true);
                        this.request(params);
                    }
                }
            }, {
                key: "hide",
                value: function hide() {
                    this.elements.container.addClass('hidden');
                }
            }, {
                key: "request",
                value: function request(values) {
                    var _this3 = this;

                    var self = this;

                    var params = this.params;

                    if (values.departure) {
                        params.departure = values.departure;
                        this.params.departure = values.departure;
                    }

                    if (values.destination) {
                        params.destination = values.destination;
                        this.params.destination = values.destination;
                    }

                    if (values.availability) {
                        params.availability = values.availability;
                        this.params.availability = values.availability;
                    }

                    if (this.offset > 0) {
                        params.offset = this.offset;
                    }

                    ajax.get('/new/charter-flight/hot-tickets', { params: params }, function (response) {
                        if (response.length > 0) {
                            if (response.length < 50) {
                                self.isAllowRequest = false;
                            }
                            self.items = response;
                            self.renderItems();
                            self.offset = self.offset + 50;
                        } else {
                            if (self.offset === 0) {
                                self.renderEmptyResult();
                                self.isAllowRequest = true;
                            } else {
                                self.isAllowRequest = false;
                            }
                            _this3.toggleLoading(false);
                        }
                    }, function (error) {
                        _this3.toggleLoading(false);
                    });
                }
            }, {
                key: "renderItems",
                value: function renderItems() {
                    var items = '';

                    this.isShowLoading = false;

                    for (var i in this.items) {
                        var item = this.items[i];
                        var $link = this.getLink(item);
                        var $direction = this.getDirection(item);
                        var $date = this.getDate(item);
                        var $price = this.getPrice(item);

                        var $flex = "<div class=\"flex\">" + $direction + $date + "</div>";

                        items += "<div class=\"hot-ticket\">" + $link + $flex + $price + "</div>";
                    }

                    var wrapper = this.elements.list.querySelector('.list-wrapper');

                    if (this.offset === 0) {
                        wrapper.innerHTML = items;
                    } else {
                        wrapper.insertAdjacentHTML('beforeend', items);
                    }

                    this.toggleLoading(false);
                }
            }, {
                key: "renderEmptyResult",
                value: function renderEmptyResult() {
                    var wrapper = this.elements.list.querySelector('.list-wrapper');
                    var title = '<div class="empty-filter-title">Кажется ничего не найдено</div>';
                    var hint = '<div class="empty-filter-hint">Попробуйте изменить параметры поиска</div>';
                    wrapper.innerHTML = "<div class=\"empty-filter-result\">" + title + hint + "</div>";
                }
            }, {
                key: "getDirection",
                value: function getDirection(item) {
                    return "<div class=\"direction\">" + item.from + " - " + item.to + "</div>";
                }
            }, {
                key: "getDate",
                value: function getDate(item) {
                    var options = { day: 'numeric', month: 'short' };
                    var dateFrom = new Date(item.dateFrom).toLocaleDateString('ru-RU', options);
                    var dateTo = '';

                    if (item.dateTo) {
                        dateTo = ' - ' + new Date(item.dateTo).toLocaleDateString('ru-RU', options);
                    }

                    return "<div class=\"date\">" + dateFrom + dateTo + "</div>";
                }
            }, {
                key: "getPrice",
                value: function getPrice(item) {
                    return "<div class=\"price\">" + item.price + " " + item.currency + "</div>";
                }
            }, {
                key: "getLink",
                value: function getLink(item) {
                    var direction = "departure=" + item.fromCode + "&destination=" + item.toCode;
                    var days = "&dateFrom=" + item.dateFrom;

                    if (item.dateTo) {
                        days = days + ("&dateTo=" + item.dateTo);
                    }

                    return "<a href=\"/new/search/avia?" + direction + days + "&adults=1&from=hotTickets\"></a>";
                }
            }, {
                key: "toggleLoading",
                value: function toggleLoading(value) {
                    eventDispatcher.dispatchEvent('_load-content', {
                        enable: value,
                        target: '#hot-tickets-list',
                        position: 'afterbegin'
                    });
                }
            }, {
                key: "scroll",
                value: function scroll() {
                    window.scrollTo({
                        top: 445,
                        behavior: 'smooth'
                    });
                }
            }]);

            return HotTickets;
        }();

        window.HotTickets = new HotTickets();
    }, {}] }, {}, [1]);